module.exports = __webpack_public_path__ + "img/js-background.7f34461a.jpeg";